@if (!isSession) {
  <div class="flyout-tags-component">
    <mat-form-field class="contact-tags-field" appearance="outline">
      <mat-label>{{ "flyout.tags.label" | translate }}</mat-label>
      <mat-chip-grid #chipList>
        @for (tag of tags; track tag) {
          <mat-chip-row
            class="tag-chip campaign-tag-chip"
            [disableRipple]="true"
            [selectable]="true"
            [removable]="true"
            (removed)="removeTagFromContact(tag.name)"
            matTooltip="{{ tag.name }}"
            matTooltipPosition="above">
            <span [style.color]="'rgb(' + tag.color + ')'">{{ tag.name }}</span>
            @if (!isSession) {
              <mat-icon [style.color]="'rgb(' + tag.color + ')'" class="contact-tag-chip-icon" matChipRemove>cancel</mat-icon>
            }
          </mat-chip-row>
        }
        <input
          placeholder="{{ isSession ? '' : ('flyout.tags.placeholder' | translate) }}"
          #campaignTagsInput
          [matAutocomplete]="auto"
          [disabled]="isSession"
          [formControl]="tagsCtrl"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="tagsSeparatorKeysCodes"
          [matChipInputAddOnBlur]="tagsAddOnBlur"
          (matChipInputTokenEnd)="addTagInputSubmitted($event)" />
      </mat-chip-grid>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addTagSelectSubmitted($event)">
        @for (tag of flyoutOpeningData.tags; track tag) {
          <mat-option [value]="tag">
            {{ tag }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
}
